import { render } from "./SelectMenuButton.vue?vue&type=template&id=5a8dc370"
import script from "./SelectMenuButton.vue?vue&type=script&lang=js"
export * from "./SelectMenuButton.vue?vue&type=script&lang=js"
script.render = render

export default script